export const CATERING = 'CATERING';
export const OLO = 'OLO';
